import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/local/pageContext';

export const LocalErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Local page (error: ${error})`);
};
